/// Paleta de acentos del diseño, usada para las iniciales y las barras.
export const SERIE = ['#1166B0', '#A1C623', '#2B90CF', '#12A039', '#29B0E6', '#6AB333'];

export const COLOR_POR_DEFECTO = '#2B90CF';

function hash(texto: string): number {
  let acumulado = 7;
  for (let i = 0; i < texto.length; i += 1) {
    acumulado = (acumulado * 31 + texto.charCodeAt(i)) % 100000;
  }
  return acumulado;
}

/// Mismo nombre, mismo color, siempre. Sin aleatoriedad ni estado.
export function colorDe(nombre: string): string {
  return SERIE[hash(nombre) % SERIE.length] ?? COLOR_POR_DEFECTO;
}

export function iniciales(nombre: string): string {
  const partes = nombre.trim().split(/\s+/).filter(Boolean);
  const primera = partes[0]?.[0] ?? '';
  const segunda = partes.length > 1 ? (partes[partes.length - 1]?.[0] ?? '') : '';
  return (primera + segunda).toUpperCase() || '?';
}
